const cantons = [
  {
    name: 'Canton de Fribourg',
    code: 'FR',
    color: 'from-amber-50 to-amber-100',
    border: 'border-amber-200',
    badge: 'bg-amber-100 text-amber-700',
    icon: 'ri-home-gear-line',
    description: 'Notre siège social est à Neuenegg (FR). Nous intervenons dans tout le canton de Fribourg pour vos travaux de rénovation, CVSE, électricité, plomberie et chauffage.',
    cities: ['Neuenegg', 'Fribourg', 'Bulle', 'Romont', 'Estavayer-le-Lac', 'Murten', 'Châtel-Saint-Denis', 'Villars-sur-Glâne', 'Givisiez', 'Marly'],
    services: ['Rénovation complète', 'Électricité NIBT/OIBT', 'Pompes à chaleur', 'Plomberie sanitaire', 'Ventilation VMC', 'Urgence 24/7'],
    highlight: true,
  },
  {
    name: 'Canton de Vaud',
    code: 'VD',
    color: 'from-green-50 to-green-100',
    border: 'border-green-200',
    badge: 'bg-green-100 text-green-700',
    icon: 'ri-landscape-line',
    description: 'HB SERVICES intervient dans tout le canton de Vaud, de Lausanne à Nyon en passant par Morges, Yverdon et la Riviera vaudoise pour tous vos besoins CVSE.',
    cities: ['Lausanne', 'Nyon', 'Morges', 'Yverdon-les-Bains', 'Renens', 'Prilly', 'Gland', 'Rolle', 'Aubonne', 'Vevey', 'Montreux', 'Aigle'],
    services: ['Chauffage & PAC', 'Installations électriques', 'Sanitaire & plomberie', 'Ventilation', 'Maintenance', 'Nettoyage'],
    highlight: false,
  },
  {
    name: 'Canton de Berne',
    code: 'BE',
    color: 'from-red-50 to-red-100',
    border: 'border-red-200',
    badge: 'bg-red-100 text-red-700',
    icon: 'ri-building-2-line',
    description: 'CasaReNovaPlus intervient dans le canton de Berne pour vos projets de rénovation et installations techniques CVSE. Devis gratuit sur demande.',
    cities: ['Berne', 'Biel/Bienne', 'Thoune', 'Köniz', 'Langenthal', 'Burgdorf', 'Lyss', 'Münsingen'],
    services: ['Rénovation', 'Électricité', 'Chauffage', 'Sanitaire', 'Ventilation', 'Domotique'],
    highlight: false,
  },
  {
    name: 'Canton du Valais',
    code: 'VS',
    color: 'from-sky-50 to-sky-100',
    border: 'border-sky-200',
    badge: 'bg-sky-100 text-sky-700',
    icon: 'ri-sun-line',
    description: 'Du Bas-Valais au Haut-Valais, HB SERVICES assure vos installations CVSE, pompes à chaleur et travaux électriques dans les stations et villes valaisannes.',
    cities: ['Sion', 'Sierre', 'Martigny', 'Monthey', 'Visp', 'Brig', 'Naters', 'Verbier', 'Crans-Montana', 'Zermatt', 'Saas-Fee'],
    services: ['Pompes à chaleur', 'Électricité', 'Chauffage', 'Sanitaire', 'Ventilation', 'Urgence'],
    highlight: false,
  },
  {
    name: 'Canton de Neuchâtel',
    code: 'NE',
    color: 'from-violet-50 to-violet-100',
    border: 'border-violet-200',
    badge: 'bg-violet-100 text-violet-700',
    icon: 'ri-water-flash-line',
    description: 'HB SERVICES intervient dans le canton de Neuchâtel pour vos projets de rénovation, installations électriques, sanitaires et systèmes de chauffage modernes.',
    cities: ['Neuchâtel', 'La Chaux-de-Fonds', 'Le Locle', 'Boudry', 'Colombier', 'Bevaix', 'Fleurier', 'Couvet'],
    services: ['Installations électriques', 'Chauffage', 'Plomberie', 'Ventilation', 'Domotique', 'Maintenance'],
    highlight: false,
  },
  {
    name: 'Canton du Jura',
    code: 'JU',
    color: 'from-orange-50 to-orange-100',
    border: 'border-orange-200',
    badge: 'bg-orange-100 text-orange-700',
    icon: 'ri-tree-line',
    description: 'Présents dans le canton du Jura pour vos besoins en installations techniques, rénovation énergétique et travaux CVSE. Contactez-nous pour un devis gratuit.',
    cities: ['Delémont', 'Porrentruy', 'Saignelégier', 'Moutier', 'Bassecourt', 'Courroux', 'Courrendlin'],
    services: ['Électricité', 'Chauffage', 'Sanitaire', 'Ventilation', 'Pompes à chaleur', 'Urgence'],
    highlight: false,
  },
  {
    name: 'Région Lémanique',
    code: 'RL',
    color: 'from-teal-50 to-teal-100',
    border: 'border-teal-200',
    badge: 'bg-teal-100 text-teal-700',
    icon: 'ri-ship-line',
    description: 'Toute la région lémanique franco-suisse : de Genève à Lausanne en passant par Nyon, Rolle, Morges et la Côte vaudoise. Interventions rapides garanties.',
    cities: ['Nyon', 'Rolle', 'Morges', 'Allaman', 'Perroy', 'Aubonne', 'Féchy', 'Begnins', 'Gland', 'Prangins'],
    services: ['CVSE complet', 'Rénovation', 'Construction', 'Domotique', 'Conciergerie', 'Aide à domicile'],
    highlight: false,
  },
];

export default function ZonesGrid() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4">
            Nos zones d&apos;intervention en <span className="text-brand-500">Suisse Romande</span>
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Une couverture complète de la Suisse romande pour tous vos travaux CVSE, électricité, plomberie et chauffage.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cantons.map((canton) => (
            <article
              key={canton.code}
              className={`relative rounded-2xl border ${canton.border} bg-gradient-to-br ${canton.color} p-6 transition-all hover:-translate-y-1 ${canton.highlight ? 'ring-2 ring-brand-500 ring-offset-2' : ''}`}
            >
              {canton.highlight && (
                <div className="absolute -top-3 left-6">
                  <span className="bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                    Siège principal
                  </span>
                </div>
              )}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl shadow-sm">
                    <i className={`${canton.icon} text-brand-500 text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 text-base leading-tight">{canton.name}</h3>
                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${canton.badge}`}>{canton.code}</span>
                  </div>
                </div>
              </div>

              <p className="text-slate-600 text-sm leading-relaxed mb-4">{canton.description}</p>

              <div className="mb-4">
                <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Villes couvertes</p>
                <div className="flex flex-wrap gap-1.5">
                  {canton.cities.map((city) => (
                    <span key={city} className="bg-white/70 text-slate-700 text-xs px-2 py-0.5 rounded-full border border-white/80">
                      {city}
                    </span>
                  ))}
                </div>
              </div>

              <div>
                <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Services disponibles</p>
                <ul className="space-y-1">
                  {canton.services.map((service) => (
                    <li key={service} className="flex items-center gap-2 text-xs text-slate-700">
                      <i className="ri-check-line text-brand-500 text-sm shrink-0"></i>
                      {service}
                    </li>
                  ))}
                </ul>
              </div>

              <a
                href="tel:+41764803188"
                className="mt-5 w-full flex items-center justify-center gap-2 bg-white border border-slate-200 hover:bg-brand-500 hover:text-white hover:border-brand-500 text-slate-700 text-sm font-semibold py-2.5 rounded-xl transition-all cursor-pointer"
              >
                <i className="ri-phone-line text-sm"></i>
                Appeler pour {canton.name.replace('Canton de ', '').replace('Canton du ', '')}
              </a>
            </article>
          ))}
        </div>

        {/* Section texte SEO riche */}
        <div className="mt-20 bg-slate-50 rounded-2xl p-8 md:p-12">
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-6">
            Entreprise de rénovation de référence en <strong>Suisse romande</strong>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-slate-600 text-sm leading-relaxed">
            <div>
              <h3 className="font-bold text-slate-800 text-base mb-3">Pourquoi choisir CasaReNovaPlus en Suisse romande ?</h3>
              <p className="mb-4">
                CasaReNovaPlus est votre partenaire de confiance pour tous vos travaux de rénovation et CVSE en Suisse romande. Basés à <strong>Neuenegg, Fribourg</strong>, nous intervenons rapidement dans les cantons de <strong>Fribourg, Berne, Vaud, Valais, Neuchâtel et Jura</strong>.
              </p>
              <p>
                Notre équipe de techniciens certifiés maîtrise les normes suisses <strong>NIBT et OIBT</strong> pour garantir des installations électriques conformes et sécurisées. Nous proposons des solutions durables et éco-responsables adaptées au climat suisse.
              </p>
            </div>
            <div>
              <h3 className="font-bold text-slate-800 text-base mb-3">Services disponibles dans toute la Suisse romande</h3>
              <ul className="space-y-2">
                {[
                  'Installations électriques conformes NIBT/OIBT',
                  'Pompes à chaleur air-eau et géothermiques',
                  'Plomberie, sanitaire et salle de bain',
                  'Ventilation VMC et climatisation',
                  'Domotique et maison connectée',
                  'Maintenance et dépannage urgence 24/7',
                  'Nettoyage professionnel et conciergerie',
                  'Aide à domicile et services aux particuliers',
                  'Gestion de projets de construction et rénovation',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <i className="ri-check-double-line text-brand-500 text-sm mt-0.5 shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
